document.addEventListener('DOMContentLoaded', () => {
  const timetable = document.querySelector('[data-component="mol-transport-timetable"]');
  if (!timetable) {
    console.warn('[LPP] timetable element not found — aborting');
    return;
  }

  const tab1 = timetable.querySelector('#transport-timetable-tab1');
  const tab2 = timetable.querySelector('#transport-timetable-tab2');

  let timerInterval1 = null;
  let timerInterval2 = null;

  function setTableState(tab, state) {
    const table = tab.querySelector('.transport-timetable__table');
    if (!table) return;
    table.classList.remove('hide', 'show-loader', 'no-result-found');
    if (state === 'hide')    table.classList.add('hide');
    if (state === 'loading') table.classList.add('show-loader');
    if (state === 'empty')   table.classList.add('no-result-found');

    const info = tab.querySelector('.transport-timetable__info');
    if (info) info.style.display = (state === 'data' || state === 'loading') ? 'none' : '';
  }

  function escHtml(str) {
    return String(str ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildRow(data) {
    const hasId = !!data.text__id;
    const rowClass = `transport-timetable__table-row text--md${hasId ? ' transport-timetable__table-row--has-line' : ''}`;

    const titleInner = hasId
      ? `<button type="button">${escHtml(data.text__title)} - <strong>${escHtml(data.text__id)}</strong></button>`
      : escHtml(data.text__title);

    const inSpan = (data.text__arrival_in_1 || data.text__arrival_in_2)
      ? `<span data-arrival-in-time>
           ${escHtml(data.text__arrival_in_1)}
           ${data.text__arrival_in_1_label ? `<strong class="text--md text--12">${escHtml(data.text__arrival_in_1_label)}</strong>` : ''}
           ${data.text__arrival_in_2 ? `, ${escHtml(data.text__arrival_in_2)}` : ''}
           ${data.text__arrival_in_2 && data.text__arrival_in_2_label ? `<strong class="text--md text--12">${escHtml(data.text__arrival_in_2_label)}</strong>` : ''}
         </span>`
      : '';

    const timeSpan = (data.text__arrival_time_1 || data.text__arrival_time_2)
      ? `<span data-arrival-time class="hide">
           ${escHtml(data.text__arrival_time_1)}
           ${data.text__arrival_time_2 ? `, ${escHtml(data.text__arrival_time_2)}` : ''}
         </span>`
      : '';

    return `<div class="${rowClass}">
      <div class="transport-timetable__table-index d-flex-cc text--uppercase">${escHtml(data.text__number || '')}</div>
      <div class="transport-timetable__table-row-inner">
        <div class="transport-timetable__table-title text--uppercase text--14">${titleInner}</div>
        <div class="transport-timetable__table-time text--14">${inSpan}${timeSpan}</div>
      </div>
    </div>`;
  }

  function renderRows(tab, rows) {
    const body = tab.querySelector('.transport-timetable__table-body');
    if (!body) return;
    body.innerHTML = rows.map(buildRow).join('');
  }

  function resetTimer(tab, intervalRef) {
    clearInterval(intervalRef);
    const timerWrapper = tab.querySelector('[data-timer]')?.parentElement;
    if (!timerWrapper) return null;

    const oldEl = timerWrapper.querySelector('[data-timer]');
    const newEl = oldEl.cloneNode(true);
    oldEl.replaceWith(newEl);
    newEl.textContent = '00:00';

    const start = Date.now();
    return setInterval(() => {
      const elapsed = Math.floor((Date.now() - start) / 1000);
      newEl.textContent = `${String(Math.floor(elapsed / 60)).padStart(2, '0')}:${String(elapsed % 60).padStart(2, '0')}`;
    }, 1000);
  }

  function bindToggle(toggleId, tab) {
    const toggle = document.getElementById(toggleId);
    if (!toggle) return;
    toggle.addEventListener('change', () => {
      const showTime = toggle.checked;
      tab.querySelectorAll('[data-arrival-in-time]').forEach((el) => el.classList.toggle('hide', showTime));
      tab.querySelectorAll('[data-arrival-time]').forEach((el) => el.classList.toggle('hide', !showTime));
    });
  }

  const activeTab = tab1 ?? tab2;
  const switchKey = tab1 ? 'arrival_switch' : 'line_arrival_switch';

  if (activeTab) {
    bindToggle(switchKey, activeTab);
  }

  let currentDirection = 'all';

  function applyDirectionFilter(direction) {
    if (!tab1) return;
    currentDirection = direction;

    tab1.querySelectorAll('[name="transport_stop"]').forEach((input) => {
      const li = input.closest('.dropdown__list-item');
      if (!li) return;
      const label = li.querySelector('.dropdown__list-option');
      const labelText = label ? label.textContent.trim() : '';
      const match = labelText.match(/\((\d+)\)\s*$/);
      const refId = match ? parseInt(match[1], 10) : null;

      let visible;
      if (direction === 'all' || refId === null) {
        visible = true;
      } else if (direction === 'to') {
        visible = refId % 2 !== 0;
      } else {
        visible = refId % 2 === 0;
      }
      li.style.display = visible ? '' : 'none';
    });
  }

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.dropdown') && currentDirection !== 'all') {
      setTimeout(() => applyDirectionFilter(currentDirection), 0);
    }
  });

  if (tab1) {
    const bothRadio = tab1.querySelector('#to-from-center-transport');
    if (bothRadio) {
      bothRadio.checked = true;
    }
    applyDirectionFilter('all');

    const submit1 = tab1.querySelector('.transport-timetable__form-submit');
    if (submit1) submit1.disabled = true;

    tab1.querySelectorAll('[name="transport_stop"]').forEach((input) => {
      input.addEventListener('change', () => {
        if (submit1) submit1.disabled = false;
      });
    });

    tab1.querySelectorAll('[name="transport_select_option"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        const dir = radio.id === 'to-center-transport'   ? 'to'
                  : radio.id === 'from-center-transport' ? 'from'
                  : 'all';
        applyDirectionFilter(dir);
        tab1.querySelectorAll('[name="transport_stop"]').forEach((i) => { i.checked = false; });
        if (submit1) submit1.disabled = true;
        renderRows(tab1, []);
        setTableState(tab1, 'hide');
        clearInterval(timerInterval1);
      });
    });
  }

  const cfg = (typeof lppTransport !== 'undefined') ? lppTransport : null;

  function getStationResults(stationId) {
    if (!stationId || !tab1) return;

    if (!cfg) {
      console.error('[LPP] lppTransport not defined — cannot call AJAX');
      setTableState(tab1, 'empty');
      return;
    }

    setTableState(tab1, 'loading');
    renderRows(tab1, []);
    clearInterval(timerInterval1);

    const url = `${cfg.ajaxUrl}?action=lpp_get_arrivals&type=1&id=${encodeURIComponent(stationId)}&_wpnonce=${encodeURIComponent(cfg.nonce)}`;

    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (!Array.isArray(data) || data.length === 0) {
          setTableState(tab1, 'empty');
          return;
        }

        const rows = data.map((group) => {
          const a1 = group[0] ?? null;
          const a2 = group[1] ?? null;
          return {
            text__number:             a1 ? String(a1.key) : '',
            text__title:              a1 ? String(a1.name) : '',
            text__arrival_in_1:       a1 ? String(a1.minutes) : '',
            text__arrival_in_1_label: a1 ? 'min' : '',
            text__arrival_in_2:       a2 ? String(a2.minutes) : '',
            text__arrival_in_2_label: a2 ? 'min' : '',
            text__arrival_time_1:     a1 ? String(a1.time) : '',
            text__arrival_time_2:     a2 ? String(a2.time) : '',
          };
        });

        renderRows(tab1, rows);
        setTableState(tab1, 'data');
        timerInterval1 = resetTimer(tab1, timerInterval1);
      })
      .catch((err) => {
        console.error('[LPP] station fetch error:', err);
        setTableState(tab1, 'empty');
      });
  }

  function getLineResults(tripId) {
    if (!tripId || !tab2) {
      return;
    }

    if (!cfg) {
      console.error('[LPP] lppTransport not defined — cannot call AJAX');
      setTableState(tab2, 'empty');
      return;
    }

    setTableState(tab2, 'loading');
    renderRows(tab2, []);
    clearInterval(timerInterval2);

    const url = `${cfg.ajaxUrl}?action=lpp_get_arrivals&type=2&id=${encodeURIComponent(tripId)}&_wpnonce=${encodeURIComponent(cfg.nonce)}`;

    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (!Array.isArray(data) || data.length === 0) {
          setTableState(tab2, 'empty');
          return;
        }

        const rows = data.map((station) => {
          const arrivals = Array.isArray(station.arrivals) ? station.arrivals : [];
          const a1 = arrivals[0] ?? null;
          const a2 = arrivals[1] ?? null;
          return {
            text__id:                 String(station.int_id ?? ''),
            text__title:              String(station.name ?? ''),
            text__arrival_in_1:       a1 ? String(a1.minutes) : '',
            text__arrival_in_1_label: a1 ? 'min' : '',
            text__arrival_in_2:       a2 ? String(a2.minutes) : '',
            text__arrival_in_2_label: a2 ? 'min' : '',
            text__arrival_time_1:     a1 ? String(a1.time) : '',
            text__arrival_time_2:     a2 ? String(a2.time) : '',
          };
        });

        renderRows(tab2, rows);
        setTableState(tab2, 'data');
        timerInterval2 = resetTimer(tab2, timerInterval2);
      })
      .catch((err) => {
        console.error('[LPP] line fetch error:', err);
        setTableState(tab2, 'empty');
      });
  }

  if (tab1) {
    const form1 = tab1.querySelector('form');
    if (form1) {
      form1.addEventListener('submit', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const checked = tab1.querySelector('[name="transport_stop"]:checked');
        if (checked) {
          getStationResults(checked.dataset.slug);
        } else {
          console.warn('[LPP] no station selected in tab1');
        }
      });
    }
  }

  if (tab2) {
    let selectedLineSlug = null;

    const submit2 = tab2.querySelector('.transport-timetable__form-submit');
    if (submit2) {
      submit2.disabled = true;
    }

    tab2.addEventListener('click', (e) => {
      const input = e.target
        .closest('.dropdown__list-option')
        ?.closest('.dropdown__list-item')
        ?.querySelector('[name="line_transport_stop"]');

      if (!input) {
        return;
      }

      selectedLineSlug = input.dataset.slug;
      if (submit2) submit2.disabled = false;
    });

    tab2.addEventListener('click', (e) => {
      const btn = e.target.closest('.transport-timetable__table-title button');
      if (!btn) return;

      const strong = btn.querySelector('strong');
      const stationId = strong ? strong.textContent.trim() : '';
      if (!stationId) return;

      const tab1Trigger = timetable.querySelector('[data-tab-id="transport-timetable-tab1"]');
      if (tab1Trigger) tab1Trigger.click();

      const input = tab1 && tab1.querySelector(`[name="transport_stop"][data-slug="${stationId}"]`);
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      getStationResults(stationId);
    });

    const form2 = tab2.querySelector('form');
    if (!form2) {
      return;
    }

    form2.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const checked = tab2.querySelector('[name="line_transport_stop"]:checked');
      const slug = checked?.dataset.slug ?? selectedLineSlug;

      if (!slug) {
        console.warn('[LPP] no line selected in tab2');
        return;
      }

      getLineResults(slug);
    });
  }

  initPlanRouteForm();
});

function initPlanRouteForm() {
  const planRouteForm = document.querySelector('#plan_route_form');
  if (planRouteForm) {
    FormValidation.formValidation(planRouteForm, {
      locale: 'sl_SI',
      localization: FormValidation.locales.sl_SI,
      plugins: {
        message: new FormValidation.plugins.Message({
          container: (field, element) =>
            element.closest('.mod-input,.checkbox,.dropdown,.radio-button,.upload-box,.form-component__item'),
        }),
        declarative: new FormValidation.plugins.Declarative({
          html5Input: true,
        }),
        trigger: new FormValidation.plugins.Trigger({
          event: 'submit',
        }),
        excluded: new FormValidation.plugins.Excluded(),
        submitButton: new FormValidation.plugins.SubmitButton(),
      },
    }).on('core.element.validated', (e) => {
      if (e.element.hasAttribute('required')) {
        const {value} = e.element;
        const container = FormValidation.utils.closest(
          e.element,
          '.mod-input, .checkbox, .dropdown, .radio-button, .upload-box, .form-component__item',
        );
        FormValidation.utils.classSet(container, {
          'is-validation-failed': value === '' || !e.valid,
        });
      }
    }).on('core.form.valid', () => {
      const start = planRouteForm.querySelector('#start_route').value.trim();
      const finish = planRouteForm.querySelector('#finish_route').value.trim();
      const url =
        'https://www.google.com/maps/dir/?api=1' +
        `&origin=${encodeURIComponent(start)}&destination=${encodeURIComponent(finish)}&travelmode=transit`;
      window.open(url, '_blank', 'noopener,noreferrer');
    });
  }
}
